import { Column, Row } from '~components/table-view';

export const errorColumns: Column[] = [
  {
    id: 'ref',
    header: 'Claim Item Ref',
    type: 'text',
  },
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'service_date',
    header: 'Service Date',
    type: 'date',
  },
  {
    id: 'reason',
    header: 'Reason',
    type: 'text',
  },
  {
    id: 'details',
    header: 'Details',
    type: 'text',
  },
];

export const warningColumns: Column[] = [
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'reason',
    header: 'Reason',
    type: 'text',
  },
  {
    id: 'details',
    header: 'Details',
    type: 'text',
  },
];

// Plain-English names for the rollback check's reason codes (TAV-3491). Unknown codes show as sent.
export const ROLLBACK_REASON_LABELS: Record<string, string> = {
  INVOICED: 'Co-contribution invoiced',
  LATER_STATEMENT: 'Following statement/s exist',
  EMAILED: 'Already emailed',
  EMAILING: 'Email being sent',
};

const rollbackReason = (row: Row): string => {
  const reason = String(row.reason ?? '');
  return ROLLBACK_REASON_LABELS[reason] ?? reason;
};

export const rollbackErrorColumns: Column[] = [
  {
    id: 'ref',
    header: 'Statement',
    type: 'text',
  },
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'reason',
    header: 'Reason',
    type: 'text',
    deriveValue: rollbackReason,
  },
  {
    id: 'details',
    header: 'Details',
    type: 'text',
  },
];

export const rollbackAffectedColumns: Column[] = [
  {
    id: 'ref',
    header: 'Statement',
    type: 'text',
  },
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'status',
    header: 'Status',
    type: 'text',
  },
];
